import React, { useState } from 'react';
import { Modal, ModalBody, Col, Row } from 'reactstrap';
import { HeaderModal, TabelaModal, NewLoader } from '../Basicos';
import { dateToPtBr } from '../Basicos/funcoes';
import ModalConsulta from './ModalConsulta';
import { axiosApi } from '../Basicos/axiosInstances';

function ModalRelatorioAlocacaoSemanal(props) {
    const { data: estrutura } = props;
    const { weeks, data } = estrutura?.modal || {};

    const [detalhesData, setDetalhesData] = useState([]);
    const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
    const [isLoadingDetalhes, setIsLoadingDetalhes] = useState(false);

    const groupedData = React.useMemo(() => {
        if (!data) return {};
        return data.reduce((acc, current) => {
            if (!acc[current.grupo]) {
                acc[current.grupo] = [];
            }
            acc[current.grupo].push(current);
            return acc;
        }, {});
    }, [data]);

    const buscarDetalhes = async (ids) => {
        if (!ids || ids.length === 0) return;
        try {
            setIsLoadingDetalhes(true);
            setModalDetalhesAberto(true);
            const response = await axiosApi.get('consultas/detalhes-alocacao-semanal', {
                params: { ids }
            });
            setDetalhesData(response.data);
        } catch (error) {
            console.error("Erro ao buscar detalhes:", error);
        } finally {
            setIsLoadingDetalhes(false);
        }
    };

    if (!weeks || !data) {
        return (
            <ModalConsulta data={props.data} size="xl" {...props}>
                <p className="text-center p-5">Carregando dados...</p>
            </ModalConsulta>
        );
    }

    const colunasDetalhes = [
        { Header: 'Data', accessor: 'data', Cell: ({ value }) => dateToPtBr(value) },
        { Header: 'Serviço', accessor: 'servico' },
        { Header: 'Professor', accessor: 'professores' },
        { Header: 'Horário', accessor: 'horario' },
    ];

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-relatorio-alocacao"
            modalBodyClass="p-0"
            size="xl"
            {...props}
        >
            <Col sm={12} className="d-flex justify-content-center p-0">
                <style>
                    {`
                        .modal-relatorio-alocacao.modal-dialog {
                            max-width: 85% !important;
                            margin: 30px auto;
                        }
                        .tabela-alocacao-container {
                            overflow-x: auto;
                            max-height: 75vh;
                            padding: 20px 0;
                            width: 100%;
                            display: flex;
                            justify-content: center;
                        }
                        .tabela-alocacao {
                            width: auto;
                            border-collapse: collapse;
                            font-family: 'Inter', sans-serif;
                            font-size: 13px;
                            border: 1px solid #1A23DF33;
                            margin-left: auto;
                            margin-right: auto;
                        }
                        .tabela-alocacao th {
                            background-color: #1A23DF;
                            color: white;
                            font-weight: 600;
                            text-align: center;
                            padding: 12px 8px;
                            border: 1px solid #1A23DF;
                            position: sticky;
                            top: 0;
                            z-index: 10;
                            min-width: 50px;
                        }
                        .tabela-alocacao td {
                            padding: 10px 8px;
                            border: 1px solid #dee2e6;
                            text-align: center;
                        }
                        .tabela-alocacao tr:nth-child(even) {
                            background-color: #f0f7ff;
                        }
                        .td-grupo {
                            font-weight: bold;
                            background-color: #ffffff !important;
                            font-size: 14px;
                            vertical-align: middle;
                            border-right: 2px solid #1A23DF;
                            color: #1A23DF;
                            min-width: 120px;
                        }
                        .td-faixa {
                            font-style: italic;
                            color: #1A23DF;
                            background-color: #f1f3f5;
                            font-weight: 500;
                        }
                        .td-total {
                            font-weight: bold;
                            background-color: #e6f0ff !important;
                            color: #1A23DF;
                            min-width: 80px;
                        }
                        .linha-separadora {
                            height: 4px;
                            background-color: #1A23DF !important;
                        }
                        .linha-separadora td {
                            padding: 0;
                            border: none;
                        }
                        .celula-clicavel {
                            cursor: pointer;
                            color: #1A23DF;
                            font-weight: 600;
                            transition: all 0.2s;
                        }
                        .celula-clicavel:hover {
                            background-color: #d0e4ff !important;
                            color: #003d80;
                        }
                        .modal-relatorio-alocacao .modal-content {
                            border: 2px solid #1A23DF;
                        }
                    `}
                </style>
                <div className="tabela-alocacao-container">
                    <table className="tabela-alocacao">
                        <thead>
                            <tr>
                                <th>GRUPOS</th>
                                <th>FAIXA</th>
                                {weeks.map((week) => (
                                    <th key={week}>{week}</th>
                                ))}
                                <th>TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedData).map(([grupo, rows], groupIndex) => (
                                <React.Fragment key={grupo}>
                                    {groupIndex > 0 && (
                                        <tr className="linha-separadora">
                                            <td colSpan={weeks.length + 3}></td>
                                        </tr>
                                    )}
                                    {rows.map((row, rowIndex) => (
                                        <tr key={`${grupo}-${row.faixa}`}>
                                            {rowIndex === 0 && (
                                                <td rowSpan={rows.length} className="td-grupo">
                                                    {grupo}
                                                </td>
                                            )}
                                            <td
                                                className="td-faixa celula-clicavel"
                                                onClick={() => row.total_ids?.length > 0 && buscarDetalhes(row.total_ids)}
                                            >
                                                ({row.faixa})
                                            </td>
                                            {weeks.map((week) => {
                                                const cell = row.semanas[week];
                                                const count = cell?.count ?? 0;
                                                const ids = cell?.ids ?? [];
                                                return (
                                                    <td
                                                        key={week}
                                                        className={count > 0 ? "celula-clicavel" : ""}
                                                        onClick={() => count > 0 && buscarDetalhes(ids)}
                                                    >
                                                        {count}
                                                    </td>
                                                );
                                            })}
                                            <td
                                                className="td-total celula-clicavel"
                                                onClick={() => row.total_ids?.length > 0 && buscarDetalhes(row.total_ids)}
                                            >
                                                {row.total_ids?.length > 0 ? row.total_ids?.length : row.total}
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Col>

            {/* Modal de Detalhes */}
            <Modal
                isOpen={modalDetalhesAberto}
                toggle={() => setModalDetalhesAberto(false)}
                size="xl"
                centered
            >
                <HeaderModal title="Detalhes da Alocação" toggle={() => setModalDetalhesAberto(false)} />
                <ModalBody>
                    <NewLoader isActive={isLoadingDetalhes}>
                        {detalhesData.length > 0 ? (
                            <TabelaModal
                                columns={colunasDetalhes}
                                data={detalhesData}
                                tabelaClassName="tabelaConsulta"
                            />
                        ) : (
                            !isLoadingDetalhes && <p className="text-center">Nenhum detalhe encontrado.</p>
                        )}
                    </NewLoader>
                </ModalBody>
            </Modal>
        </ModalConsulta>
    );
}

export default ModalRelatorioAlocacaoSemanal;
